
document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('.nav-toggle');
  const links = document.querySelector('.nav-links');
  const overlay = document.querySelector('.header-overlay');

  const setMenu = (open, returnFocus = true) => {
    if (!toggle || !links) return;
    links.classList.toggle('open', open);
    overlay?.classList.toggle('open', open);
    document.body.classList.toggle('menu-open', open);
    toggle.setAttribute('aria-expanded', String(open));
    toggle.setAttribute('aria-label', open ? 'Close navigation' : 'Open navigation');
    if (!open && returnFocus && window.innerWidth <= 900) {
      toggle.focus();
    }
  };

  toggle?.addEventListener('click', () => setMenu(!links.classList.contains('open')));
  overlay?.addEventListener('click', () => setMenu(false));
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && links?.classList.contains('open')) setMenu(false);
  });
  links?.addEventListener('keydown', event => {
    if (event.key !== 'Tab' || window.innerWidth > 900 || !links.classList.contains('open')) return;
    const menuLinks = [...links.querySelectorAll('a[href]')];
    const first = menuLinks[0];
    const last = menuLinks[menuLinks.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); toggle.focus(); }
    if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); toggle.focus(); }
  });
  toggle?.addEventListener('keydown', event => {
    if (event.key !== 'Tab' || window.innerWidth > 900 || !links?.classList.contains('open')) return;
    const menuLinks = [...links.querySelectorAll('a[href]')];
    if (event.shiftKey) { event.preventDefault(); menuLinks.at(-1)?.focus(); }
    else { event.preventDefault(); menuLinks[0]?.focus(); }
  });
  links?.querySelectorAll('a').forEach(link => link.addEventListener('click', () => {
    if (window.innerWidth <= 900) setMenu(false, false);
  }));


  // Close the mobile menu cleanly if the viewport returns to desktop.
  window.addEventListener('resize', () => {
    if (window.innerWidth > 900 && links?.classList.contains('open')) setMenu(false);
  });

  // Smooth-scroll only genuine in-page anchors whose targets exist.
  document.querySelectorAll('a[href^="#"]:not([href="#"])').forEach(anchor => {
    anchor.addEventListener('click', event => {
      const target = document.querySelector(anchor.getAttribute('href'));
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
    });
  });

  // Give real forms visible feedback while preserving Shopify's native submit flow.
  document.querySelectorAll('[data-product-form], [data-membership-form], [data-newsletter-form]').forEach(form => {
    form.addEventListener('submit', event => {
      if (form.matches('[data-ajax-membership]')) return;
      if (!form.checkValidity()) return;
      const button = event.submitter || form.querySelector('button[type="submit"]');
      if (!button || button.disabled) return;
      button.dataset.originalText = button.textContent;
      button.textContent = button.dataset.loadingLabel || 'Please wait…';
      button.setAttribute('aria-busy', 'true');
      button.disabled = true;
      // Restore controls if browser navigation is cancelled or Shopify returns to the page.
      setTimeout(() => {
        if (!document.contains(button)) return;
        button.disabled = false;
        button.removeAttribute('aria-busy');
        button.textContent = button.dataset.originalText || button.dataset.submitLabel || 'Submit';
      }, 5000);
    });
  });

  document.querySelectorAll('[data-product-root]').forEach(root => {
    const select = root.querySelector('[data-variant-select]');
    const price = root.querySelector('[data-product-price]');
    const compare = root.querySelector('[data-compare-price]');
    const button = root.querySelector('[data-add-button]');
    const status = root.querySelector('[data-product-status]');
    const planSelect = root.querySelector('[data-selling-plan-select]');
    const monthlyPrice = root.querySelector('[data-product-monthly-price]');
    const variantsNode = root.querySelector('[data-variants-json]');
    const allocationsNode = root.querySelector('[data-allocations-json]');
    const subscriptionPricesNode = root.querySelector('[data-subscription-prices-json]');
    if (!select || !variantsNode) return;

    let variants = [];
    let allocations = {};
    let subscriptionPrices = {};
    try { variants = JSON.parse(variantsNode.textContent); } catch (_) {}
    try { allocations = JSON.parse(allocationsNode?.textContent || '{}'); } catch (_) {}
    try { subscriptionPrices = JSON.parse(subscriptionPricesNode?.textContent || '{}'); } catch (_) {}

    const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency',
      currency: root.dataset.currency || 'USD'
    }).format(cents / 100);

    const update = () => {
      const variant = variants.find(v => String(v.id) === String(select.value));
      if (!variant) return;
      if (price) price.textContent = money(variant.price);
      if (monthlyPrice) monthlyPrice.textContent = money(subscriptionPrices[String(variant.id)] ?? variant.price);
      if (compare) {
        compare.textContent = variant.compare_at_price > variant.price ? money(variant.compare_at_price) : '';
        compare.hidden = !(variant.compare_at_price > variant.price);
      }
      if (button) {
        button.disabled = !variant.available;
        button.textContent = variant.available ? button.dataset.availableLabel : button.dataset.soldLabel;
      }
      if (status) { status.textContent = variant.available ? 'Available for dispatch' : 'Currently unavailable'; status.setAttribute('aria-live', 'polite'); }

      if (planSelect) {
        const validPlans = allocations[String(variant.id)] || [];
        [...planSelect.options].forEach(option => {
          if (!option.value) return;
          option.hidden = !validPlans.includes(String(option.value));
          option.disabled = !validPlans.includes(String(option.value));
        });
        if (planSelect.selectedOptions[0]?.disabled) {
          const firstValid = [...planSelect.options].find(o => !o.disabled && !o.hidden);
          if (firstValid) planSelect.value = firstValid.value;
        }
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url);
    };
    select.addEventListener('change', update);
    update();
  });
});


/* Archive membership AJAX cart */
(() => {
  const forms = [...document.querySelectorAll('[data-ajax-membership]')];
  if (!forms.length) return;

  const drawer = document.querySelector('[data-archive-cart-drawer]');
  const overlay = document.querySelector('[data-archive-cart-overlay]');
  const closeButton = document.querySelector('[data-archive-cart-close]');
  const itemName = document.querySelector('[data-archive-cart-item]');
  const message = document.querySelector('[data-archive-cart-message]');
  const countCopy = document.querySelector('[data-archive-cart-count]');
  let returnFocus = null;

  const root = window.Shopify?.routes?.root || '/';

  const updateCartCount = count => {
    document.querySelectorAll('.cart-count').forEach(node => {
      node.textContent = count;
      node.hidden = count < 1;
    });
    document.querySelectorAll('.cart-link').forEach(link => {
      let badge = link.querySelector('.cart-count');
      if (!badge && count > 0) {
        badge = document.createElement('span');
        badge.className = 'cart-count';
        link.appendChild(badge);
      }
      if (badge) {
        badge.textContent = count;
        badge.hidden = count < 1;
      }
    });
  };

  const openDrawer = (name, count) => {
    if (!drawer || !overlay) return;
    if (itemName) itemName.textContent = name;
    if (countCopy) countCopy.textContent = count === 1 ? '1 item in your ledger' : `${count} items in your ledger`;
    overlay.hidden = false;
    requestAnimationFrame(() => {
      overlay.classList.add('is-visible');
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      closeButton?.focus();
    });
  };

  const closeDrawer = () => {
    if (!drawer || !overlay) return;
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-visible');
    drawer.setAttribute('aria-hidden', 'true');
    setTimeout(() => { overlay.hidden = true; }, 320);
    returnFocus?.focus();
  };

  closeButton?.addEventListener('click', closeDrawer);
  overlay?.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && drawer?.classList.contains('is-open')) closeDrawer();
  });

  forms.forEach(form => {
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      const button = event.submitter || form.querySelector('button[type="submit"]');
      if (!button || button.disabled) return;

      returnFocus = button;
      const original = button.dataset.submitLabel || button.textContent;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      button.textContent = button.dataset.loadingLabel || 'Registering correspondence…';
      form.classList.remove('has-error');

      try {
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: new FormData(form)
        });

        const added = await response.json();
        if (!response.ok) throw new Error(added.description || added.message || 'The membership could not be added.');

        const cartResponse = await fetch(`${root}cart.js`, {
          headers: { 'Accept': 'application/json' }
        });
        const cart = await cartResponse.json();

        updateCartCount(cart.item_count || 0);
        button.classList.add('is-registered');
        button.textContent = button.dataset.successLabel || 'Correspondence registered';

        const membershipName = form.dataset.membershipName || added.product_title || 'Archive membership';
        if (message) {
          message.textContent = `Your ${membershipName} membership has been added to your correspondence ledger.`;
        }
        openDrawer(membershipName, cart.item_count || 1);

        setTimeout(() => {
          button.classList.remove('is-registered');
          button.disabled = false;
          button.removeAttribute('aria-busy');
          button.textContent = original;
        }, 2400);
      } catch (error) {
        form.classList.add('has-error');
        let errorNode = form.querySelector('.membership-form-error');
        if (!errorNode) {
          errorNode = document.createElement('div');
          errorNode.className = 'membership-form-error';
          errorNode.setAttribute('role', 'alert');
          form.appendChild(errorNode);
        }
        errorNode.textContent = error.message || 'The Archive could not register this correspondence. Please try again.';
        button.disabled = false;
        button.removeAttribute('aria-busy');
        button.textContent = original;
      }
    });
  });
})();


/* Accessible Archive opening sequence */
(() => {
  const opening = document.querySelector('[data-archive-opening]');
  if (!opening) return;
  const key = opening.dataset.sessionKey || 'pendleberry-opening';
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  let seen = false;
  try { seen = sessionStorage.getItem(key) === 'seen'; } catch (_) {}
  if (reduced || seen || (window.Shopify && window.Shopify.designMode)) { opening.remove(); return; }

  const scene = opening.querySelector('[data-opening-scene]');
  const back = opening.querySelector('.archive-opening__face--back');
  const letterShell = opening.querySelector('.archive-opening__letter-shell');
  const turn = opening.querySelector('[data-envelope-turn]');
  const envelopeFront = opening.querySelector('[data-envelope-front]');
  const seal = opening.querySelector('[data-opening-seal]');
  const skip = opening.querySelector('[data-opening-skip]');
  const closeButton = opening.querySelector('[data-opening-close]');
  const pageRegions = [...document.body.children].filter(node => node.tagName !== 'SCRIPT' && node !== opening && !node.contains(opening));
  const previouslyFocused = document.activeElement;

  const setPageInert = value => {
    pageRegions.forEach(node => {
      if (value) {
        node.setAttribute('inert', '');
        node.setAttribute('aria-hidden', 'true');
      } else {
        node.removeAttribute('inert');
        node.removeAttribute('aria-hidden');
      }
    });
    document.body.classList.toggle('opening-active', value);
  };

  const focusable = () => [...opening.querySelectorAll('button:not([disabled]), a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')]
    .filter(element => !element.closest('[aria-hidden="true"]') && !element.hasAttribute('inert'));

  const close = () => {
    try { sessionStorage.setItem(key, 'seen'); } catch (_) {}
    opening.classList.add('is-closing');
    opening.setAttribute('aria-hidden', 'true');
    setPageInert(false);
    setTimeout(() => {
      opening.remove();
      const target = document.querySelector('#MainContent');
      (previouslyFocused && previouslyFocused !== document.body ? previouslyFocused : target)?.focus?.();
    }, 500);
  };

  const turnEnvelope = () => {
    if (scene.classList.contains('is-turned') || scene.classList.contains('is-turning')) return;
    scene.classList.add('is-settled', 'is-turning');
    turn?.setAttribute('disabled', 'disabled');
    setTimeout(() => {
      scene.classList.remove('is-turning');
      scene.classList.add('is-turned');
      setTimeout(() => seal?.focus(), 520);
    }, 500);
  };

  const openLetter = () => {
    if (!scene.classList.contains('is-turned') || scene.classList.contains('is-turning') || back.classList.contains('is-open')) return;
    scene.classList.add('is-letter-open');
    back.classList.add('is-open');
    letterShell?.removeAttribute('inert');
    letterShell?.setAttribute('aria-hidden', 'false');
    setTimeout(() => closeButton?.focus(), 1750);
  };

  setPageInert(true);
  requestAnimationFrame(() => {
    opening.classList.add('is-visible');
    opening.setAttribute('aria-hidden', 'false');
    setTimeout(() => scene?.classList.add('is-settled'), 700);
    turn?.focus();
  });

  turn?.addEventListener('click', event => { event.stopPropagation(); turnEnvelope(); });
  envelopeFront?.addEventListener('click', event => {
    if (event.target.closest('button,a,input,select,textarea')) return;
    turnEnvelope();
  });
  seal?.addEventListener('click', openLetter);
  skip?.addEventListener('click', close);
  closeButton?.addEventListener('click', close);
  opening.addEventListener('keydown', event => {
    if (event.key === 'Escape') { event.preventDefault(); close(); return; }
    if (event.key !== 'Tab') return;
    const items = focusable();
    if (!items.length) { event.preventDefault(); opening.focus(); return; }
    const first = items[0];
    const last = items[items.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });
})();

/* Viewport-triggered parchment unfurl */
(() => {
  const papers = [...document.querySelectorAll('[data-unfurl]')];
  if (!papers.length) return;

  if (
    window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
    !('IntersectionObserver' in window)
  ) {
    papers.forEach(paper => paper.classList.add('is-unfurled'));
    return;
  }

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-unfurled');
      observer.unobserve(entry.target);
    });
  }, { threshold: .16, rootMargin: '0px 0px -8% 0px' });

  papers.forEach(paper => observer.observe(paper));
})();

/* Archive correspondence preference dropdown */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-archive-select]').forEach(root => {
    const button = root.querySelector('[data-archive-select-button]');
    const menu = root.querySelector('[data-archive-select-menu]');
    const input = root.querySelector('[data-archive-select-input]');
    const value = root.querySelector('[data-archive-select-value]');
    const options = [...root.querySelectorAll('[role="option"]')];
    if (!button || !menu || !input || !value || !options.length) return;

    let activeIndex = options.findIndex(option => option.getAttribute('aria-selected') === 'true');
    if (activeIndex < 0) activeIndex = 0;

    const setActive = index => {
      activeIndex = (index + options.length) % options.length;
      options.forEach((option, i) => option.classList.toggle('is-active', i === activeIndex));
      options[activeIndex].focus();
    };

    const open = focusSelected => {
      menu.hidden = false;
      root.classList.add('is-open');
      button.setAttribute('aria-expanded', 'true');
      if (focusSelected) requestAnimationFrame(() => setActive(activeIndex));
    };

    const close = returnFocus => {
      menu.hidden = true;
      root.classList.remove('is-open');
      button.setAttribute('aria-expanded', 'false');
      options.forEach(option => option.classList.remove('is-active'));
      if (returnFocus) button.focus();
    };

    const choose = option => {
      activeIndex = options.indexOf(option);
      input.value = option.dataset.value || option.textContent.trim();
      value.textContent = option.textContent.trim();
      options.forEach(item => {
        const selected = item === option;
        item.setAttribute('aria-selected', String(selected));
        item.classList.toggle('is-selected', selected);
      });
      close(true);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    };

    button.addEventListener('click', () => menu.hidden ? open(true) : close(false));
    button.addEventListener('keydown', event => {
      if (['ArrowDown', 'ArrowUp', 'Enter', ' '].includes(event.key)) {
        event.preventDefault();
        open(true);
        if (event.key === 'ArrowUp') setActive(activeIndex - 1);
      }
    });

    options.forEach((option, index) => {
      option.addEventListener('click', () => choose(option));
      option.addEventListener('mousemove', () => {
        activeIndex = index;
        options.forEach((item, i) => item.classList.toggle('is-active', i === activeIndex));
      });
      option.addEventListener('keydown', event => {
        if (event.key === 'ArrowDown') { event.preventDefault(); setActive(activeIndex + 1); }
        if (event.key === 'ArrowUp') { event.preventDefault(); setActive(activeIndex - 1); }
        if (event.key === 'Home') { event.preventDefault(); setActive(0); }
        if (event.key === 'End') { event.preventDefault(); setActive(options.length - 1); }
        if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); choose(option); }
        if (event.key === 'Escape' || event.key === 'Tab') close(event.key === 'Escape');
      });
    });

    document.addEventListener('pointerdown', event => {
      if (!root.contains(event.target) && !menu.hidden) close(false);
    });
  });
});

/* Dragon Naturalist Order questionnaire */
(() => {
  const roots = [...document.querySelectorAll('[data-naturalist-quiz]')];
  if (!roots.length) return;

  const orderNames = {
    elderwood: 'Elderwood',
    cinderyn: 'Cinderyn',
    noctis: 'Noctis',
    aetheron: 'Aetheron',
    merovar: 'Merovar'
  };
  const tieBreakQuestions = [5, 6, 2, 3, 4, 1];
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  roots.forEach(root => {
    const form = root.querySelector('[data-naturalist-form]');
    const quiz = root.querySelector('[data-quiz]');
    if (!form || !quiz) return;

    const questions = [...quiz.querySelectorAll('[data-question]')];
    const submit = quiz.querySelector('[data-quiz-submit]');
    const error = quiz.querySelector('[data-quiz-error]');
    const tagsInput = form.querySelector('[data-naturalist-tags]');
    const noteInput = form.querySelector('[data-naturalist-note]');
    const nameInput = form.querySelector('[data-naturalist-name]');
    const emailInput = form.querySelector('[data-naturalist-email]');
    const endpoint = (root.dataset.mailerliteEndpoint || '').trim();
    let sending = false;

    const selectedForQuestion = questionNumber => form.querySelector(`input[name="question_${questionNumber}"]:checked`)?.value || '';

    const calculateOrder = () => {
      const scores = Object.keys(orderNames).reduce((all, order) => ({ ...all, [order]: 0 }), {});
      questions.forEach((_, index) => {
        const answer = selectedForQuestion(index + 1);
        if (answer && Object.hasOwn(scores, answer)) scores[answer] += 1;
      });
      const highest = Math.max(...Object.values(scores));
      const tied = Object.keys(scores).filter(order => scores[order] === highest);
      if (tied.length > 1) {
        for (const questionNumber of tieBreakQuestions) {
          const answer = selectedForQuestion(questionNumber);
          if (tied.includes(answer)) return { order: answer, scores };
        }
      }
      return { order: tied[0] || 'elderwood', scores };
    };

    const setFieldError = (input, message) => {
      const wrap = input?.closest('[data-field-wrap]');
      const fieldError = wrap?.querySelector('[data-field-error]');
      if (!input || !fieldError) return;
      input.setAttribute('aria-invalid', 'true');
      fieldError.textContent = message;
      fieldError.hidden = false;
    };

    const clearFieldError = input => {
      const wrap = input?.closest('[data-field-wrap]');
      const fieldError = wrap?.querySelector('[data-field-error]');
      input?.removeAttribute('aria-invalid');
      if (fieldError) fieldError.hidden = true;
    };

    const validateDetails = () => {
      let valid = true;
      const name = (nameInput?.value || '').trim();
      const email = (emailInput?.value || '').trim().toLowerCase();
      clearFieldError(nameInput);
      clearFieldError(emailInput);

      if (!name) {
        setFieldError(nameInput, 'Please enter your first name.');
        valid = false;
      }
      if (!email || !emailPattern.test(email) || !emailInput?.checkValidity()) {
        setFieldError(emailInput, 'Please enter a valid email address, such as name@example.com.');
        valid = false;
      }
      if (!valid) (name ? emailInput : nameInput)?.focus();
      return valid;
    };

    const prepareSubmission = () => {
      const { order, scores } = calculateOrder();
      const marketing = form.querySelector('input[name="contact[accepts_marketing]"]')?.checked || false;
      const answers = questions.map((_, index) => ({ question: index + 1, order: selectedForQuestion(index + 1) }));
      const baseTags = ['pendleberry-naturalist-application', `order-${order}`];
      if (marketing) baseTags.push('newsletter');
      if (tagsInput) tagsInput.value = baseTags.join(', ');
      if (noteInput) {
        const answerLine = answers.map(answer => `Q${answer.question}: ${orderNames[answer.order] || 'No response'}`).join(' | ');
        const scoreLine = Object.entries(scores).map(([key, value]) => `${orderNames[key]} ${value}`).join(', ');
        noteInput.value = `Dragon Naturalist Order: ${orderNames[order]}. Scores: ${scoreLine}. Answers: ${answerLine}.`;
      }
      return {
        first_name: nameInput.value.trim(),
        email: emailInput.value.trim().toLowerCase(),
        order,
        order_name: orderNames[order],
        scores,
        answers,
        marketing_consent: marketing,
        assessed_at: new Date().toISOString(),
        source: 'pendleberry-order-quiz'
      };
    };

    const showSuccess = () => {
      form.innerHTML = `
        <div class="naturalist-success" role="status" aria-live="polite" tabindex="-1">
          <div class="wax">P</div>
          <div class="eyebrow">Application received</div>
          <h3>Your application has crossed safely into the Archive.</h3>
          <p>Your answers have been sealed for the Head Keepers of the Dragon Orders to consider. When your Order has been determined, your name will be entered into the Registry of Pendleberry Dragon Naturalists and your commissioning papers will find their way to the email address you provided.</p>
          <p class="naturalist-success__aside">Keep watch upon your inbox, and perhaps your promotions or spam folder too, should an Archive owl take the scenic route.</p>
        </div>`;
      form.querySelector('.naturalist-success')?.focus();
      form.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
    };

    questions.forEach(question => {
      question.addEventListener('change', () => {
        question.classList.remove('has-error');
        question.removeAttribute('aria-invalid');
        if (error) error.hidden = true;
      });
    });

    [nameInput, emailInput].forEach(input => {
      input?.addEventListener('input', () => clearFieldError(input));
      input?.addEventListener('blur', () => {
        if (input === nameInput && !input.value.trim()) setFieldError(input, 'Please enter your first name.');
        if (input === emailInput && (!emailPattern.test(input.value.trim()) || !input.checkValidity())) setFieldError(input, 'Please enter a valid email address, such as name@example.com.');
      });
    });

    form.addEventListener('submit', async event => {
      questions.forEach(question => { question.classList.remove('has-error'); question.removeAttribute('aria-invalid'); });
      const unansweredIndex = questions.findIndex((_, index) => !selectedForQuestion(index + 1));
      if (unansweredIndex !== -1) {
        event.preventDefault();
        const unanswered = questions[unansweredIndex];
        unanswered.classList.add('has-error');
        unanswered.setAttribute('aria-invalid', 'true');
        if (error) {
          error.textContent = `Please answer question ${unansweredIndex + 1} before submitting your application.`;
          error.hidden = false;
        }
        unanswered.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
        unanswered.querySelector('input[type="radio"]')?.focus({ preventScroll: true });
        return;
      }
      if (!validateDetails()) {
        event.preventDefault();
        return;
      }

      const payload = prepareSubmission();
      if (!endpoint) return;

      event.preventDefault();
      if (sending) return;
      sending = true;
      const originalText = submit?.textContent || 'Submit my application';
      if (submit) {
        submit.disabled = true;
        submit.textContent = submit.dataset.loadingLabel || 'Sending to the Archive…';
      }
      if (error) error.hidden = true;

      try {
        const response = await fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });
        const body = await response.json().catch(() => ({}));
        if (!response.ok) throw new Error(body.message || 'The Archive could not receive your application.');
        showSuccess();
      } catch (submissionError) {
        if (error) {
          error.textContent = submissionError.message || 'The correspondence route is temporarily unavailable. Please try again.';
          error.hidden = false;
        }
        if (submit) {
          submit.disabled = false;
          submit.textContent = originalText;
        }
        sending = false;
      }
    }, { capture: true });
  });
})();

/* Occasional dragon crossings -------------------------------------------------
   A tiny, low-frequency ambient detail. Respects reduced-motion preferences,
   pauses in background tabs, and never captures pointer events. */
(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (reducedMotion.matches) return;



  let timer;

  const schedule = (minimum = 26000, maximum = 52000) => {
    clearTimeout(timer);
    timer = window.setTimeout(launch, Math.round(minimum + Math.random() * (maximum - minimum)));
  };

  const launch = () => {
    if (document.hidden || reducedMotion.matches || document.querySelector('.archive-flyby')) {
      schedule(12000, 24000);
      return;
    }

    const flyby = document.createElement('div');
    const leftToRight = Math.random() > 0.42;
    const duration = 9.5 + Math.random() * 3.5;
    const top = 14 + Math.random() * 62;
    const size = 31 + Math.random() * 18;
    const drift = -18 + Math.random() * 36;

    flyby.className = `archive-flyby ${leftToRight ? 'archive-flyby--ltr' : 'archive-flyby--rtl'}`;
    flyby.setAttribute('aria-hidden', 'true');
    flyby.style.setProperty('--flyby-top', `${top}vh`);
    flyby.style.setProperty('--flyby-size', `${size}px`);
    flyby.style.setProperty('--flyby-duration', `${duration}s`);
    flyby.style.setProperty('--flyby-drift', `${drift}px`);
    flyby.innerHTML = `<span class="archive-flyby__trail"></span><span class="archive-flyby__dragon"></span>`;

    document.body.appendChild(flyby);
    flyby.addEventListener('animationend', () => flyby.remove(), { once: true });
    schedule();
  };

  const start = () => schedule(14000, 22000);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('visibilitychange', () => {
    if (!document.hidden && !document.querySelector('.archive-flyby')) schedule(10000, 20000);
  });
})();

/* Product gallery: side-by-side archive plates on desktop; carousel + swipe on mobile */
(() => {
  const galleries = [...document.querySelectorAll('[data-product-gallery]')];
  if (!galleries.length) return;

  const mobileGallery = window.matchMedia('(max-width: 768px)');

  galleries.forEach(gallery => {
    const slides = [...gallery.querySelectorAll('[data-product-slide]')];
    const previous = gallery.querySelector('[data-gallery-prev]');
    const next = gallery.querySelector('[data-gallery-next]');
    const current = gallery.querySelector('[data-gallery-current]');
    const viewport = gallery.querySelector('.product-gallery__viewport');
    if (!slides.length) return;

    let index = Math.max(0, slides.findIndex(slide => slide.classList.contains('is-active')));
    if (index < 0) index = 0;

    const show = newIndex => {
      index = (newIndex + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-current', active ? 'true' : 'false');
        if (!active && mobileGallery.matches) {
          slide.querySelectorAll('video').forEach(video => video.pause?.());
        }
      });
      if (current) current.textContent = String(index + 1);
    };

    show(index);

    if (slides.length < 2 || !previous || !next) return;

    previous.addEventListener('click', () => show(index - 1));
    next.addEventListener('click', () => show(index + 1));

    gallery.addEventListener('keydown', event => {
      if (!mobileGallery.matches) return;
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        show(index - 1);
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        show(index + 1);
      }
    });

    if (viewport) {
      let startX = null;
      let startY = null;

      viewport.addEventListener('touchstart', event => {
        if (!mobileGallery.matches || event.touches.length !== 1) return;
        startX = event.touches[0].clientX;
        startY = event.touches[0].clientY;
      }, { passive: true });

      viewport.addEventListener('touchend', event => {
        if (!mobileGallery.matches || startX === null || event.changedTouches.length !== 1) return;
        const deltaX = event.changedTouches[0].clientX - startX;
        const deltaY = event.changedTouches[0].clientY - startY;
        startX = null;
        startY = null;

        if (Math.abs(deltaX) < 45 || Math.abs(deltaX) <= Math.abs(deltaY)) return;
        show(deltaX < 0 ? index + 1 : index - 1);
      }, { passive: true });
    }
  });
})();

